import React, { useEffect, useRef, useState } from "react";
import { sendDocuseal } from "../../../apis/docusealApi";
import { DocusealForm } from "@docuseal/react";
import { useParams, useNavigate } from "react-router-dom";
import NotFound from "../ErrorMessage/error";

const popupStyle = {
  position: "absolute",
  width: "100%",
  maxWidth: "182px",
  height: "22px",
  cursor: "pointer",
  // backgroundColor: "coral",
  color: "white",
  zIndex: 10,
  overflow: "hidden",
  // padding: '10px',
  // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)'
};
const pageTitleBox = {
  width: "100%",
  maxWidth: "1000px",
  margin: "30px auto",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "end",
};
const Docuseal = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [data, setData] = useState(null);
  const ref = useRef();
  const logoRef = useRef();
  const [show, setShow] = useState(false);
  const [top, setTop] = useState(2000);
  const [left, setLeft] = useState(430);

  useEffect(() => {
    setShow(false);
    const handleResize = () => {
      if (show) {
        console.log(ref.current.clientWidth, "ref.current.clientWidth0");
        // popupStyle.top = `${ref.current.clientHeight - (ref.current.clientHeight/100*25)} px`
        if (logoRef.current.clientWidth < 380) {
          console.log(ref.current.clientWidth, "ref.current.clientWidth1");

          setLeft(50);
          // setTop(ref.current.clientHeight - (ref.current.clientHeight/100*35))
          setTop(100);
        } else if (logoRef.current.clientWidth < 1700) {
          console.log(ref.current.clientWidth, "ref.current.clientWidth2");

          setLeft(
            (ref.current.clientWidth - logoRef.current.clientWidth) / 2 + 600
          );
          // setLeft(logoRef.current.clientWidth > 1000 ? (logoRef.current.clientWidth/100*27)  : 100)
          setTop(
            ref.current.clientHeight - (ref.current.clientHeight / 100) * 28
          );
        } else {
          console.log(ref.current.clientWidth, "ref.current.clientWidth3");

          setLeft((logoRef.current.clientWidth / 100) * 55);
          setTop(
            ref.current.clientHeight - (ref.current.clientHeight / 100) * 28
          );
        }
      }
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoading(true);
      const res = await sendDocuseal(id);
      if (res.success) {
        setData(res.result);
      } else {
        setError(true);
        setErrorMessage("The URL is expired or invalid.");
      }
      setLoading(false);
    } catch (e) {
      setError(true);
      setErrorMessage(
        "The URL you are trying to access has expired or is no longer valid."
      );
      setLoading(false);
    }
  };

  const handleComplete = (data) => {
    console.log("Form Completed:", data);
    navigate("/submit-success");
  };

  if (error) {
    return <NotFound message={errorMessage} />;
  }

  return (
    <div>
      {loading && <div>Loading...</div>}
      {!loading && !error && data && (
        <div className="app">
          <div style={{ ...pageTitleBox }} ref={logoRef}></div>
          <div ref={ref}>
            <DocusealForm
              src={`https://docuseal.co/d/${data.docusealSlug}`}
              email={
                data?.subscriptionInfo?.subSubscribers?.subscribers?.email ||
                "shaik.zuber@greenman.com"
              }
              allowToResubmit={false}
              autoscrollFields={true}
              minimize={true}
              withTitle={false}
              onComplete={handleComplete}
              onLoad={(data) => {
                setTimeout(() => {
                  console.log(
                    ref.current.clientWidth,
                    "ref.current.clientWidth"
                  );
                  // popupStyle.top = `${ref.current.clientHeight - (ref.current.clientHeight/100*25)} px`
                  if (logoRef.current.clientWidth < 380) {
                    setLeft(50);
                    // setTop(ref.current.clientHeight - (ref.current.clientHeight/100*35))
                    setTop(100);
                  } else if (logoRef.current.clientWidth < 1700) {
                    setLeft(
                      (ref.current.clientWidth - logoRef.current.clientWidth) /
                        2 +
                        600
                    );
                    // setLeft(logoRef.current.clientWidth > 1000 ? (logoRef.current.clientWidth/100*27)  : 100)
                    setTop(
                      ref.current.clientHeight -
                        (ref.current.clientHeight / 100) * 31.2
                    );
                  } else {
                    setLeft((logoRef.current.clientWidth / 100) * 35);
                    setTop(
                      ref.current.clientHeight -
                        (ref.current.clientHeight / 100) * 28
                    );
                  }
                  setShow(true);
                }, 2000);
              }}
            />
          </div>
        </div>
      )}
      <div>
        {show && (
          <div
            ref={ref}
            className="docuseal_mobile"
            style={{ ...popupStyle, top: `${top}px`, left: `${left}px` }}
            onClick={() =>
              window.open(
                "https://www.greenmanopen.com/de/terms-and-conditions-for-the-mobile-app-de/"
              )
            }
          >
            <a
              href="https://www.greenmanopen.com/de/terms-and-conditions-for-the-mobile-app-de/"
              target="new"
            >
              {" "}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default Docuseal;
